// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__t9uoi","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__pYiqL"};